export const hover_item = (hovered, antToken, type, height = 45) => {    
	if (type == "invoices") return {
		"background-color": hovered? antToken.colorBgLayout : "",
		"height": hovered? height * 1.1: height,
		"transition": "all 0.1s ease",
		"borderRadius": "10px",
		"cursor": "pointer",
		"borderBottom": `1px solid ${antToken.colorBgLayout}`
	};

	else return {
		"background-color": antToken.colorBgLayout,
		"cursor": "pointer",
		"transition": "all 0.1s ease",
		"borderBottom": `1px solid ${antToken.colorBgLayout}`
	};
};